/* eslint-disable react/prop-types */
import React from 'react'
import {
  Edit, SimpleForm, TextInput, required, SelectInput, Toolbar, SaveButton, BooleanInput,
} from 'react-admin'

// Removes the delete button
const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

const UserEdit = (props) => (
  <Edit {...props}>
    <SimpleForm toolbar={<UserEditToolbar />}>
      <TextInput disabled label="Nom" source="lastname" validate={required()} />
      <TextInput disabled label="Prénom" source="name" validate={required()} />
      <BooleanInput label="Joueur" source="handicap" />
      <SelectInput
        label="Changer le rôle"
        source="authority"
        allowEmpty="false"
        choices={[
          { id: 'admin', name: 'Administrateur' },
          { id: 'organiser', name: 'Organisateur' },
          { id: 'user', name: 'Utilisateur' },
        ]}
      />
    </SimpleForm>
  </Edit>
)

export default UserEdit
